<template>
    <div id="content_page">
        <v-slide-x-transition>
            <div>
                <div class="hero">
                    <h4>
                        Posez vos questions, parcourez nos articles et trouvez vos réponses.
                    </h4>
                    <router-link to="./contact">
                        Vous ne trouvez pas votre réponse ? Contactez-nous !
                    </router-link>
                    <v-flex xs12 sm6 md4 offset-sm3 offset-md4 mt-5>
                        <v-text-field v-model="search" solo label="Search" align-center justify-center />
                    </v-flex>
                </div>
                <v-layout row wrap>
                    <v-flex v-for="(question, index) in filteredQuestions" :key="index" xs12 sm6>
                        <v-card>
                            <v-card-title primary-title>
                                <div class="custom_card_title">
                                    <h3 class="headline mb-3">
                                        {{ question.title }}
                                    </h3>
                                    <p v-html="question.response" />
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </div>
        </v-slide-x-transition>
    </div>
</template>

<script>
    import faqSupport from '../components/support/faqSupport';

    export default {
        name: 'Support',
        data: () => ({
            number: 0,
            search: '',
            questions: faqSupport
        }),
        computed: {
            filteredQuestions: function () {
                return this.questions.filter((question) => {
                    if (question.title.match(this.search)) {
                        return question;
                    }
                    if (question.response.match(this.search)) {
                        return question;
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

    .flex {
        padding: 10px !important;
    }

    #content_page {
        padding: 20px;
    }

    .v-card {
        height: 100%;

        & h3 {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-align: left;
            font-size: 25px !important;
        }

        & p {
            display: -webkit-box;
            text-align: left;
            font-size: initial;
            line-height: initial;
        }
    }

    .v-btn {
        bottom: 0;

        &:hover {
            color: #FFF !important;
        }
    }

    #search_bar {
        transform: scale(1.2);
        padding-top: 20px;
        float: inherit;
        margin: auto;

        & .search_bar {
            width: 300px;
            margin-left: 25px;
        }

        & span {
            width: 100px;
        }

        & input:focus {
            left: -25px;

            & ~ span {
                right: -150px;
            }
        }
    }

    .line {
        width: 1px !important;
        height: 100% !important
    }

    .bigFas {
        font-size: 30px;
    }

    .media {
        white-space: nowrap;
        overflow: hidden;
    }

    .tile {
        width: 100%;
    }

    #questionContainer {
        display: grid;
        grid-template-columns: repeat(2, 45%);
        grid-gap: 1%;
        row-gap: 15px;
        padding-top: 20px;
    }

    .light {
        font-weight: 300;
    }

    .content, .fas {
        color: #393E46 !important
    }

    #question_detail {
        hyphens: auto;
        text-align: left;
    }

    .faq_answer {
        padding-top: 10px;
    }

    @media screen and (max-width: 768px) {
        #questionContainer {
            display: grid;
            grid-template-columns: repeat(1, 92%);
            grid-gap: 1%;
            row-gap: 0px;
            padding-top: 20px;
        }

        #search_bar {
            display: initial;
            top: 10px;
            position: relative;

            & input {
                width: 100vw;
            }
        }

        .faq_question {
            font-size: 20px !important;
        }

        .faq_answer p {
            font-size: 14px;
        }

        .responsive_fixed {
            position: fixed;
            z-index: 10;
            width: 100vw;
            padding-left: 4%;
            padding-right: 4%;
            background-color: #F1F1F1;
            margin: 0 !important;
        }

        .responsive_content {
            position: relative;
            top: calc(12vh);
        }
    }

    .custom_card_title, .custom_card_title p {
        width: 100%;
    }

    .custom_btn_item_color {
        background-color: #169CEB !important;
        color: white;
    }

</style>
